import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { loanStateLabel, loanStateTone } from '../status'
import type { Book, Loan } from '../types'

export function AvailabilityBadge({
  book,
  size = 'sm',
}: {
  book: Pick<Book, 'availableCopies' | 'totalCopies' | 'active'>
  size?: 'sm' | 'md'
}) {
  const { t } = useTranslation('library')
  if (!book.active)
    return (
      <Badge tone="neutral" size={size}>
        {t('Withdrawn')}
      </Badge>
    )
  if (book.availableCopies === 0)
    return (
      <Badge tone="warning" size={size} dot>
        {t('All on loan')}
      </Badge>
    )
  return (
    <Badge tone="success" size={size} dot>
      {t('{{available}} of {{total}} available', {
        available: book.availableCopies,
        total: book.totalCopies,
        count: book.availableCopies,
      })}
    </Badge>
  )
}

export function LoanStateBadge({
  loan,
  size = 'sm',
}: {
  loan: Pick<Loan, 'state' | 'daysOverdue'>
  size?: 'sm' | 'md'
}) {
  const { t } = useTranslation('library')
  return (
    <Badge tone={loanStateTone[loan.state]} size={size} dot>
      {loan.state === 'overdue'
        ? t('Overdue · {{days}}d', { days: loan.daysOverdue })
        : t(loanStateLabel[loan.state])}
    </Badge>
  )
}
